import axios from "@/index";
const country = {
  state: {
    baseDataCountryCodeList: [],
    countryData: [],
    brandInfo: [],
    editBrandInfo: {},
    allCountryInfo: []
  },
  getters: {},
  actions: {
    getBaseDataCountryCodeList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setBaseDataCountryCodeList",
                (state, { baseDataCountryCodeList: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getCountryInfoById: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setCountryInfoById",
                (state, { countryData: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getBrandInfoList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit("setBrandInfoList", (state, { brandInfo: response.data }));
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getCountryInfo: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setCountryInfo",
                (state, { allCountryInfo: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mutations: {
    setBaseDataCountryCodeList(state, action) {
      state.baseDataCountryCodeList = action.baseDataCountryCodeList;
    },
    setCountryInfoById(state, action) {
      state.countryData = action.countryData;
    },
    setBrandInfoList(state, action) {
      state.brandInfo = action.brandInfo;
    },
    setCountryInfo(state, action) {
      state.allCountryInfo = action.allCountryInfo;
    }
  }
};
export default country;
